const common = {
    no_data: 'Walang available na data',
    header: {
        business_name: 'Ang Iyong Negosyo'
    },
    download_app: {
        text: 'Para magamit ang Simply web version, mangyaring gumamit ng laptop o PC.',
        button: 'I-download ang mobile version'
    },
    unknown: 'Hindi alam',
    request_error: 'Nagkaroon ng error. Pakisubukan ulit! O makipag-ugnayan sa customer support para i-report ang iyong isyu.',
    home: 'Home',
    dashboard: 'Dashboard',
    product: 'Produkto',
    add_product: 'Magdagdag ng Produkto',
    edit_product: 'I-edit ang Produkto',
    stock_in: 'Stock In',
    Sales_Turnover: 'Benta',
    profit: 'Kita',
    stock_out: 'Stock Out',
    staff: 'Staff',
    stock_audit: 'Stock Audit',
    button: {
        save: 'I-save',
        save_and_add_more: 'I-save at Magdagdag Pa',
        submit: 'Isumite',
        done: 'Tapos Na',
        edit: 'I-edit',
        save_edit: 'I-save ang Mga Pagbabago',
        yes: 'Oo',
        clear: 'I-clear',
        delete: 'Burahin',
        cancel: 'Kanselahin',
        reset: 'I-reset'
    },
    select_date: 'Piliin ang Petsa',
    select_action: 'Piliin ang Aksyon',
    mandatory: ' *(Kailangan)',
    not_mandatory: '(Hindi Kailangan)',
    business: 'Negosyo',
    account: 'Account',
    profile: 'Profile',
    setting: 'Mga Setting',
    whichLanguage: 'Tagalog',
    headerDashboard: 'Maging VIP',
    contact_us: 'Makipag-ugnayan sa Amin',
    logout: 'Mag-logout',
    category: 'Kategorya',
    add_category: 'Magdagdag ng Kategorya',
    data: 'Data',
    history: 'Kasaysayan',
    lowStockAlert: 'Babala sa Mababang Stock',
    Expenses: 'Mga Gastos',
    lowStockAlertButton: 'Magdagdag ng Safety Stock Quantity',
    message: {
        login_success: 'Matagumpay na Nakalog-in!',
        onboard_success: 'Hooray!! Nagsimula na ang iyong paglalakbay!',
        successfully_saved: 'Matagumpay na na-save ang data',
        successfully_deleted: 'Matagumpay na nabura ang data',
        error_required_field: 'Hindi maaaring walang laman ang required field',
        no_access: 'Walang access',
        no_permission: 'Wala kang permiso',
        error_update_history: 'Nabigo sa pag-update ng history'
    },
    no_permission_dialog: {
        title: 'Walang Pahintulot',
        description: 'Wala kang pahintulot na tingnan ang Mga Gastos. Mangyaring makipag-ugnayan sa iyong administrator.'
    },
    feedback: 'Magbigay ng Feedback',
    contact: 'Kontak',
    add: 'Magdagdag',
    supplier: 'Tagapagbigay',
    customer: 'Customer',
    random: 'Random',
    scan: 'I-scan',
    enter: 'Mag-login sa pamamagitan ng pag-scan ng barcode',
    terms: {
        text: 'Sa pagpapatuloy, sumasang-ayon ka sa',
        link: 'Privacy Policy'
    },
    others: 'Iba pa',
    calender: {
        presets: {
            today: 'Ngayon',
            yesterday: 'Kahapon',
            last_7_days: 'Huling 7 Araw',
            last_30_days: 'Huling 30 Araw',
            this_month: 'Sa Buwang Ito',
            last_month: 'Nakaraang Buwan',
            custom_range: 'Custom Range'
        }
    },
    print_large: 'I-print Malaki (A4)',
    print_letter: 'I-print ang Letter (US)',
    print_dot_matrix: 'I-print Malaki (Dot Matrix)',
    print_medium: 'I-print Katamtaman (75mm)',
    print_small: 'I-print Maliit (48mm)',
    format: 'Format ng Papel',
    preview: 'Preview',
    view_invoice: 'Invoice',
    view_chalan: 'Challan',
    price: 'Presyo',
    stock: 'Stock',
    quantity: 'Dami',
    total: 'Kabuuan',
    print_footer_left: 'Ginawa ni',
    print_footer_center: 'Na-print noong',
    print_footer_date: 'sa',
    print_to: 'Kay',
    language: 'Tagalog',
    dateStatus: 'Huling 7 Araw',
    placeholder: 'Uri ng Transaksyon',
    staffHistory: 'Piliin ang Staff',
    languageTitle: 'Tagalog',
    date: 'Petsa',
    download: 'I-download',
    download_excel: 'I-download ang Excel',
    download_pdf: 'I-download ang Barcode',
    currentTitle: 'Pera',
    Selectperiod: 'Piliin ang panahon',
    TransactionType: 'Uri ng Transaksyon',
    SelectCustomer: 'Piliin ang Customer',
    invoice: 'Invoice',
    login: {
        google: 'Mag-login gamit ang Google',
        apple: 'Mag-login gamit ang Apple'
    },
    trusted_by: {
        title: 'Pinagkakatiwalaan ng mahigit 50,000 negosyo \n sa buong Indonesia 🇮🇩'
    },
    privacyPolicyOne: "Sa pag-sign in, sumasang-ayon ka sa Privacy Policy ng Simply",
    privacyPolicyTwo: 'Privacy Policy',
    manufacture: 'Paggawa',
    warehouse: 'Mga Warehouse',
    error: {
        title: 'Oops! May nangyaring mali',
        description: 'May hindi inaasahang error na nangyari. Subukan mong i-refresh ang page o bumalik sa home.',
        refresh: 'Refresh Page',
        go_back: 'Bumalik sa Home',
        not_found: 'Page Not Found'
    },
    totalPurchasePrice: 'Kabuuan ng Presyo ng Bili',
    pageTotalPurchaseAmount: 'Kabuuan ng Halaga ng Bili sa Pahina',
    approval_status: 'Katayuan ng pag-apruba',
    pending: 'Nakabinbin',
    approved: 'Inaprubahan',
    rejected: 'Tinanggihan',
    select_fields: 'Piliin ang mga field',
    syncWithTally: 'I-sync sa Tally',
    importFromTally: 'Mag-import mula sa Tally',
    exportToTally: 'Mag-export sa Tally',
    All: 'Lahat',
    Approval: 'Pag-apruba'
}
export default common